import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../appStores';

/**
 * Los botones típicos de las tiendas (negros, con el logo). Las imágenes
 * viven en public/tiendas y son las mismas de la landing (assets/).
 */
export function BotonesTiendas({ alto = 40, className }: { alto?: number; className?: string }): JSX.Element {
  const ancho = Math.round((alto * 150) / 44);
  return (
    <span className={['tiendas', className].filter(Boolean).join(' ')}>
      <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
        <img src="/tiendas/app-store.svg" width={ancho} height={alto} alt="Descárgalo en el App Store" />
      </a>
      <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
        <img src="/tiendas/google-play.svg" width={ancho} height={alto} alt="Disponible en Google Play" />
      </a>
    </span>
  );
}
